import { render, staticRenderFns } from "./SidebarLogoMorph.vue?vue&type=template&id=6a5c0692&scoped=true"
import script from "./SidebarLogoMorph.vue?vue&type=script&lang=js"
export * from "./SidebarLogoMorph.vue?vue&type=script&lang=js"
import style0 from "./SidebarLogoMorph.vue?vue&type=style&index=0&id=6a5c0692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5c0692",
  null
  
)

export default component.exports